export const getHeaderSettings = () =>
    window.parent["Insticator"] !== undefined ? window.parent["Insticator"]["settings"] :
        window.parent.parent["Insticator"] !== undefined ? window.parent.parent["Insticator"]["settings"] : null;

export const getUserGeoSetting = () => {
    const headerSettings = getHeaderSettings();
    return !!headerSettings && !!headerSettings.visitorGeo ? headerSettings.visitorGeo : null;
};

export const isDMPEnabled = () =>  {
    const headerSettings = getHeaderSettings();
    return !!headerSettings && !!headerSettings.dmpEnabled ? headerSettings.dmpEnabled : false;
};
export const isGDPRCountry = countryCode => {
    const GDPRStates = ['BE', 'BG', 'CZ', 'DK','DE', 'EE', 'IE', 'EL', 'ES', 'FR', 'HR', 'IT', 'CY', 'LV', 'LT', 'LU', 'HU', 'MT', 'NL', 'AT', 'PL', 'PT', 'RO', 'SI', 'SK', 'FI', 'SE', 'UK', 'GB '];
    return GDPRStates.includes(countryCode);
};
